export class RackZoneEndCustomerRequest{
    endCustomerId: number;
    constructor(endCustomerId: number){
        this.endCustomerId = endCustomerId;
    }
}